import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { ScrollButton } from './ui/ScrollButton';
import { scrollToCompra } from '../utils/scroll';
export function HeroSection() {
  const features = ['150 fichas de actividades listas para imprimir', '6 tomos de guía paso a paso para el adulto', 'Sistema completo desde las vocales hasta la escritura autónoma', 'Instrucciones claras para el adulto en cada actividad', 'Todo lo que el niño necesita: solo lápiz y papel', 'Funciona en casa y en el aula con el mismo código'];
  return <section className="relative bg-white overflow-hidden" data-id="element-80">
      <div className="min-h-[100svh] flex flex-col justify-center px-4 py-4 md:py-12" data-id="element-81">
        <div className="max-w-5xl mx-auto w-full" data-id="element-82">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-83">
            <p className="text-[#C4A7E7] font-semibold text-xs md:text-xl mb-1.5 md:mb-5" data-id="element-84">
              Para docentes, profesionales y familias que acompañan a niños con
              autismo y sienten que el tiempo pasa… pero el avance no llega.
            </p>

            <h1 className="text-[1.35rem] leading-[1.15] md:text-5xl lg:text-6xl font-extrabold text-[#111111] md:leading-tight mb-1.5 md:mb-5 tracking-tight" data-id="element-85">
              ¿Seguís buscando actividades para tu hijo con autismo que{' '}
              <span className="text-[#C4A7E7]" data-id="element-86">realmente funcionen?</span>
            </h1>

            <p className="text-[0.8rem] leading-snug md:text-2xl text-[#111111] mb-1 md:mb-3 md:leading-relaxed max-w-3xl mx-auto" data-id="element-87">
              Con el{' '}
              <strong className="text-[#C4A7E7] font-black" data-id="element-88">
                MEGA KIT ALFABETIZACIÓN EN AUTISMO
              </strong>{' '}
              tenés todo el sistema listo para trabajar lectoescritura con niños
              autistas en casa y en el aula.
            </p>

            <p className="text-[#C4A7E7] font-bold text-xs md:text-xl mb-1.5 md:mb-8" data-id="element-89">
              Descargás hoy. Imprimís hoy. Empezás hoy.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex justify-center mb-2 md:mb-6" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/kUEsDKg5zmDB3j6uvVzXP7/WhatsApp_Image_2026-03-17_at_8.55.38_PM-removebg-preview.png" loading="eager" decoding="async" alt="Mega Kit Alfabetización en Autismo" className="w-48 md:w-full md:max-w-md h-auto object-contain drop-shadow-2xl cursor-pointer" onClick={scrollToCompra} data-id="element-91" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.15
        }} className="max-w-3xl mx-auto" data-id="element-92">
            <div className="text-center mb-1 md:mb-4" data-id="element-93">
              <h2 className="text-sm md:text-3xl font-black text-[#C4A7E7] mb-0.5 md:mb-2" data-id="element-94">
                MEGA KIT ALFABETIZACIÓN EN AUTISMO™
              </h2>
              <p className="text-xs md:text-xl text-[#111111] font-medium leading-tight md:leading-relaxed" data-id="element-95">
                El primer sistema de alfabetización para autismo que une la casa
                y la escuela con el mismo código visual.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl md:rounded-2xl px-3 py-2 md:p-8 mb-2.5 md:mb-6" data-id="element-96">
              <h3 className="text-xs md:text-xl font-bold text-[#111111] mb-1 md:mb-2 flex items-center justify-center gap-1.5 md:gap-2" data-id="element-97">
                <span className="bg-[#C4A7E7] text-[#111111] px-2 py-0.5 md:px-3 md:py-1 rounded-md md:rounded-lg text-[0.6rem] md:text-sm font-bold" data-id="element-98">
                  NUEVO
                </span>
                6 Tomos + 150 Fichas + 7 Bonos
              </h3>
              <p className="text-gray-600 mb-2 md:mb-5 text-[0.65rem] md:text-base text-center leading-tight" data-id="element-99">
                Para nivel inicial y primario. Para casa y para el aula.
                Descarga inmediata. Cero material extra.
              </p>

              <ul className="grid grid-cols-2 gap-x-2 gap-y-1 md:grid-cols-1 md:space-y-3 md:gap-0 max-w-xl mx-auto" data-id="element-100">
                {features.map((feature, idx) => <li key={idx} className="flex items-start gap-1.5 md:gap-3" data-id="element-101">
                    <div className="mt-0.5 bg-[#C4A7E7]/20 p-0.5 md:p-1 rounded-full flex-shrink-0" data-id="element-102">
                      <CheckIcon className="w-2.5 h-2.5 md:w-4 md:h-4 text-[#C4A7E7]" strokeWidth={3} data-id="element-103" />
                    </div>
                    <span className="text-[#111111] font-medium text-[0.65rem] leading-tight md:text-base md:leading-normal" data-id="element-104">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.25
        }} className="max-w-sm md:max-w-md mx-auto" data-id="element-105">
            <ScrollButton fullWidth variant="primary" data-id="element-106">
              ✅ SÍ, QUIERO EL MEGA KIT →
            </ScrollButton>
          </motion.div>
        </div>
      </div>
    </section>;
}